export default {
  en: {
    login: {
      invalid_ip: "It cannot be accessed from the customer's network environment. Please access again from the network environment to which you have permission. If you are unsure of the network environment you can access, please contact the administrator.",
      heading: 'Online seminars made easy!',
      subHeading: '',
      forgotPassword: 'Forgot your account password?',
      remember: 'Remember me',
      passwordLable: 'Password',
      emailLable: 'Email address',
      requiredField: 'This field is required',
      buttonLabel: 'login',
      invalidPassword: 'Invalid password, please try again',
      noUser: 'User not found, please try again!',
      emailNotFound: 'Email not found!',
      title: 'Lite FreshVoice connected in 2 seconds',
      maxAttemptExceed: 'Maximum number of login limit exceed, Please try again after 5 minutes.',
      fetching: "Fetching..."
    },
    footerMenu: {
      about:
        '<a class="link white" href="https://www.anets.co.jp/e/">About Us</a>',
      terms:
        '<a class="link black" href="https://workshop-live.com/term-en.html?la=en">Terms of Service</a>',
      policy:
        '<a class="link black" href="https://workshop-live.com/privacy-en.html?la=en">Privacy Policy</a>',
      developedBy: 'created by '
    },
    loggedOutNavigation: {
      home: 'HOME',
      register: 'create account'
    },
    roomRecordings: {
      room_name: 'Room name\n (Mode)',
      started_at: 'Start',
      ended_at: 'End',
      user_started: 'User',
      file: 'Watch Recording',
      download: 'Download',
      fetchingRecordings: 'Fetching Recodings',
      noRecordings: 'No Recordings till now',
      duration: 'Duration',
      hours: 'h',
      minutes: 'm',
      seconds: 's',
      confirmation:'Do you want to delete?',
      mixedVideo: 'Mixed',
      play: 'Play',
      recordingTranscriptionSearch: "Recording transcription search",
      videoDownload: "Video\n Download",
      transcription: "Transcription",
      transcriptionDownload: "Transcription CSV \nDownload",
      delete: "Delete",
      withSubtitle: "With Subtitle",
      withoutSubtitle: "Without Subtitle"
    },
    loggedInNavigation: {
      IPAddresses: 'IP address restrictions',
      activityLogs: "Activity Logs",
      emailAddressBook: "Email address book",
      roomRecordings: "Room Recordings",
      lockRoom: "Lock Room",
      managePlans: 'Manage Plans',
      adminDashboard: 'Admin Dashboard',
      guestDashboard: 'Guest Dashboard',
      roleAdmin: 'Administer',
      roleGuest: 'Guest',
      contacts: 'Contacts',
      settings: 'Settings',
      recordings: 'Recordings',
      seminars: 'Seminars',
      rooms: 'Rooms',
      upgrade: 'upgrade account',
      new: 'New Seminar',
      modalHeader: 'Upgrade account to Admin?',
      upgradeConfirmation: 'Are you sure you want to upgrade to a Admin?',
      upgradeModalBody:
        'Admin users can create a new seminar and also join in a seminar invited by others.',
      cancel: 'cancel',
      gotoAdmin: 'Go to admin dashboard',
      gotoGuest: 'Go to guest dashboard',
      logout: 'logout',
      adminster: 'Guest cannot create new seminars.',
      manual: 'Manual',
      notice: 'Notice',
      fvlite_room: 'Conference mode',
      webinar_rooms: 'Webinar mode',
      createRoom: 'Create room',
      createEditRoom: "Create and edit room",
      enterRoom: 'Conference mode: Join a room',
      roomPlaceholder: 'Please enter a room name',
      passwordPlaceholder: 'Input password here',
      copyGuestUrl: 'Conference mode: Copy invitation URL',
      copyHostUrl: 'Conference mode: Copy host URL',
      copyUrl: 'Conference mode: Copy invitation URL',
      deleteRoom: 'Delete',
      deleteRoomMessage: 'Are you sure you want to delete the room?',
      deleteConfirmation: 'Some users are still connected in the room, are you sure you want to delete the room?',
      urlCopy: 'URL has been successfully copied.',
      hostUrlCopy: 'Host URL is copied.',
      roomNameLength: 'Room name should contain maximum 20 characters',
      copyWebinarUrl: 'Webinar mode: Copy invitation URL',
      copyWebinarPublisherUrl: 'Webinar mode: Copy host URL',
      enterWebinarRoom: 'Webinar mode: Join a room',
      webinarUrlCopiedMessage: 'Webinar URL has been copied',
      webinarPublisherUrlCopiedMessage: 'Webinar publisher URL has been copied',
    },
    seminar: {
      registration: 'register',
      beginsIn: 'Seminar begins in',
      register: 'Go to Registration Page',
      guests: 'Guests',
      open: 'Go to Seminar Page',
      upcoming: 'upcoming',
      previous: 'previous',
      deleteSeminar: 'delete seminar',
      declineInvite: 'decline invitation',
      acceptInvite: 'accept invitation',
      openSeminar: 'Seminar URL',
      deleteModalHeading: 'Delete Seminar?',
      deleteConfirm: {
        sure: 'Are you sure you want to DELETE ',
        seminar: ' Seminar? ',
        guestNumbers: ' '
      },
      deleteButtonLabel: 'delete seminar',
      delMessage: 'Workshop seminar Room has been removed',
      schedule: 'Seminar schedule',
      scheduleUpdated: 'Schedule Updated',
      date: 'Seminar Date',
      time: '12hr Format',
      save: 'save',
      notScheduled: 'Time not schedued',
      dateNot: 'Date not scheduled',
      scheduleNext: 'Please schedule your next seminar',
      createNew: 'Create new Seminar',
      seminarName: 'Seminar name',
      on: 'ON',
      off: 'OFF',
      record: 'Record Seminar?',
      create: 'create',
      mobile: 'Discussion Mode?',
      hour: "hour",
      min: "min"
    },
    seminarActions: {
      members: 'Members',
      select: 'selected',
      selectList: 'select list',
      tabs: {
        details: 'details',
        schedule: 'schedule',
        invite: 'invite',
        recording: 'recording',
        settings: 'settings'
      },
      name: 'Seminar name',
      description: 'Seminar description',
      noDescription: 'No description found',
      addPassword: 'Add page password?',
      saveDetails: 'SAVE DETAILS',
      clear: 'clear',
      removedMessage: ' Removed',
      addParticipant: 'add participant',
      previewEmail: '[Users] Trial Signup Email',
      import: 'import',
      invite: 'Invite & Manage participants',
      inviteSubheading: 'Add manually, share a link or import a list or CSV.',
      tableHeading: {
        guests: 'Guests',
        email: 'Email Address',
        user: 'Register/User'
      },
      tableOptions: {
        add: 'Add',
        import: 'Import List',
        sendAll: 'Send Invite to ALL Participants',
        removeAll: 'Remove ALL Participants'
      },
      sentEmailMessage: 'Sent email invite to ',
      participants: ' participants',
      multipleRemovedMessage: ' participants removed',
      selected: ' participants selected',
      singleRemoved: ' Removed',
      send: 'Send Invites',
      remove: 'Remove Guests',
      tooltipInvite: 'Send invite email',
      tooltipRemove: 'Remove',
      noParticipants:
        'You have no participants in your seminar, please add some',
      removeModal: {
        heading: 'Remove ',
        body: 'Are you sure you want to REMOVE ',
        seminar: ' from seminar?'
      },
      dismiss: 'dismiss'
    },
    inviteModal: {
      invited: ' invited to seminar',
      inviteParticipant: 'Invite Participant',
      name: 'participant name',
      student: 'Student',
      teacher: 'Teacher',
      facilitator: 'Facilitator',
      invite: 'invite',
      listWith: ' lists with ',
      imported: ' contacts imported',
      shareToImport: 'Share contact list to import',
      listLelected: ' Lists selected',
      membersSelected: ' members selected',
      inviteAll: 'Invite ',
      participantToSeminar: ' Participants to Seminar?',
      noParticipants: 'No participants to import',
      sureNotify: 'Are you sure you want to notify and INVITE ALL ',
      all: 'invite all',
      sentInvite: 'Sent invite to ALL ',
      participants: ' Participants',
      deletedAllMessage: 'All Participants removed from seminar',
      sureRemoveAll:
        'Are you sure you want to REMOVE ALL Participants to the seminar?',
      removeAll: 'remove all',
      recording: {
        date: 'Date',
        name: 'Name',
        size: 'Size',
        duration: 'Duration',
        download: 'download',
        play: 'play',
        404: 'No recordings found',
      },
      settings: {
        global: 'Global settings for ',
        timezone: 'Timezone',
        language: 'Language',
        bitrate: 'Bitrate',
        videoCodec: 'Video Codec',
        turn: 'Force Turn Server',
      },
    },
    previewModal: {
      subject: 'Subject',
      body: 'Body',
      save: 'save',
      default: 'set default',
      close: 'CLOSE',
      success: 'Email content updated successfully'
    },
    forgotPassword: {
      sent: 'Email sent. ',
      sendAgain: 'Send link again?',
      successLine1: 'We\'ve sent you a link to change',
      successLine2: 'your password',
      checkSpam: 'If you don’t see our email, check your spam folder',
      resetByEMail: 'Reset your password by email',
      buttonLabel: 'send link'
    },
    signUp: {
      heading: 'Sign up for free!',
      doneHeading: 'Thanks for signing up!',
      passwordError: {
        short: 'Password too short, atleast 6 characters required',
        alphaNumeric: 'Password must contain only alphabets or numbers',
        dontMatch: 'Passwords don\'t match',
        long: 'Password too long, It must contains 20 characters only',
        required: 'Password is required'
      },
      emailError: 'Email format is not correct',
      admin: 'Admin',
      guest: 'Guest',
      agree: 'By creating an account you agree to our',
      and: ' and ',
      confirmPasswordLabel: 'Confirm password',
      emailTaken: 'Email has already been taken',
      createAccount: 'create account',
      usernameLabel: 'Username',
      phoneNumeric: 'Phone Number must contain numbers'.localeCompare,
      phoneValid: 'Please enter a valid phone number',
      phoneLabel: 'Phone Number',
      companyLabel: 'Company Name',
      trialTitle: 'free trial',
      trialDays: '14 days',
      startTrial: 'Start your trial',
      userplaceholder: 'Yamada'
    },
    signupComplete: {
      hi: 'Hi ',
      thanks: 'Thanks for signing up, please check your',
      activate: 'email to activate your account',
      redirect: 'Redirecting you in ',
      thanksActivate: 'Thanks for Account Activation',
      expiredHeading: 'Expired URL',
      expiredText: 'You\'ve jumped to the expired url Try again.',
      ActivationText:
        'Thanks Thanks Thanks for the activation, please login and create new seminar with workshop',
      resetSuccessfullMessage:
        'Your password has been updeted. you can now login with the new password',
      successChangeEmail: 'Success for Changing Email Address',
      changeEmailSuccessfullMessage:
        'You succeeded to change the email address, now you can login with the new email address.'
    },
    seminars: {
      emptyRoom: 'No rooms found, please create a rooms'
    },
    contacts: {
      genToken: 'Generate API Token',
      revokeToken: 'Revoke API Token ',
      copyApiToken: 'Copy API Token',
      csvImport: 'CSV Import',
      importCsv: 'Import CSV File',
      supportedFormat: 'Supported Format',
      chooseCsv: 'Choose CSV file',
      listName: 'List Name',
      create: 'Create List',
      list: 'List',
      edit: 'edit name',
      delete: 'delete',
      add: 'Add Person',
      role: 'Role',
      selected: ' guests selected',
      remove: 'Remove Guests',
      removed: ' guests removed',
      tooltipEdit: 'edit contact',
      tooltipRemove: 'Remove',
      userEdited: 'user edited',
      userAdded: 'user added',
      name: 'Guest name',
      save: 'save',
      addLabel: 'add',
      editLabel: 'edit',
      deleteList: 'Delete List',
      sureDelete: 'Are you sure you want to DELETE this list?'
    },
    settings: {
      account: 'account',
      billing: 'Billing & usage',
      unlimited: 'unlimited',
      picMessage: 'Picture updated',
      userType: 'User type',
      saved: 'Saved',
      confirmDelete: 'Confirm deletion of account',
      deleteAccount: 'Delete account??',
      typeMessage: {
        type: 'Type ',
        accountName: ' to confirm deletion of your account.',
        delete: 'DELETE'
      },
      sureDelete: 'Are you sure you want to delete your account?',
      deleteMessage:
        'All past and future seminars will be deleted and you will not have access to your account anymore',
      deleteButtonLabel: 'delete account',
      updateEmail: 'Check the confimation email',
      emailAlreadyGot: 'This email has already used'
    },
    picture: {
      take: 'Take',
      upload: 'Upload',
      picture: 'picture!',
      dropImage: 'Drop an image or click to select a file to upload.',
      confirm: 'confirm',
      takePic: 'take picture'
    },
    plan: {
      failedCount: 'Numbers of the payment failure',
      failedDate: 'Date of the payment failure',
      changePlan: 'Change Plan',
      serviceEndDate: 'Services End Date',
      nextBillingDate: 'Next Billing Date',
      moveOn: 'Proceed',
      successChangedPlan: 'You have successfully changed your plan.',
      updatingPlan: 'Updating plan...',
      installless: 'No installation needed',
      expired: 'Trial Expired',
      trialEndsIn: ' days left in exipration of Trial Plan',
      premium: 'Premium',
      trialPeriod: '2 Weeks Trial',
      initialPrice: 'Initial Price',
      totalPrice: 'Total Price',
      yen: 'yen',
      yourPlan: 'Your plan',
      plan: ' plan',
      enjoyBenefits:
        'Enjoy all the benefits of Workshop free features. Please check your usage details below:',
      seminarsMonth: 'Seminars a month',
      concurrentSeminars: 'Concurrent Seminar',
      maxParticipants: 'Max Participants',
      recordingStorage: 'Seminar recording storage',
      upgradeAccess: 'Upgrade to access',
      enjoyMore:
        'To enjoy more features of Workshop please upgrade and visit our plans page for more details.',
      contactUs:
        'Please contact us if you require a custom applications or integrations for your Workshop account. Email: nakajima@anets.co.jp',
      mangePlan: 'Plan Detail',
      currentPlan: 'current plan',
      backToFree: 'Cancel Plan',
      upgrade: 'upgrade',
      upgradeFailed: 'Upgrade Failed!',
      paymentFailed:
        'The payment has failed due to some reason, try again later?',
      close: 'close',
      changing: 'Changing Plan?',
      noRefund: 'No Refund Warning.',
      sure: 'Are you sure you want to ',
      upgradeTo: 'upgrade to ',
      switchBack: 'switch back to a Free account?',
      warning:
        'If you purchase a paid Workshop plan and then downgrade to a Free plan after using the paid plan, Anet Co., Ltd is not able to issue refunds for unused service.'
    },
    mangePlan: {
      ccInfo: 'Current credit card information',
      expired: 'Expiration Date',
      paymentHistory: 'Payment History',
      settings: 'Settings',
      manage: 'Manage plans',
      heading:
        'Simple pricing for all! Select a plan that suites your needs, alternatively contact us if you require a customized solution.',
      monthly: 'Monthly contract',
      yearly: 'Yearly contract 20% OFF',
      month: 'month',
      year: 'year',
      updateCard: 'update card',
      updateCreditCard: 'update credit card',
      FAQ: 'Frequent Questions'
    },
    planFeatures: {
      feature1: 'x3 Seminars a month',
      featureNotFree1: 'Unlimited Seminars',
      tooltip1: 'The maximum number of active seminar rooms allocated',
      feature2: 'Breakout Rooms',
      tooltip2: 'Create mini rooms inside seminars for further discussion',
      feature3: {
        upTo: 'up to ',
        participants: ' participants'
      },
      tooltip3: 'The maximum number participants allowed per seminar',
      feature4: 'Text Chat',
      tooltip4:
        'Users can communicate with each other by text chat during the seminars.',
      feature5: 'Contact Management',
      tooltip5: 'Contact lists can be imported when inviting the participants.',
      feature6: '1 Concurrent Seminar',
      tooltip6: 'Manage and run multiple seminars at the same time',
      feature7: 'GB Seminar Recording',
      tooltip7: 'The maximum storage size for the recoding file',
      feature8: 'Email Support',
      tooltip8: 'We support users by email if you need help'
    },
    planHeading: {
      per: '/ per ',
      zero: '¥0 forever!',
      monthly: 'or ¥240,000 yearly equal to ¥20,000 per month',
      yearly: 'or ¥720,000 yearly equal to ¥60,000 per month',
      freeHeading: 'For a taste of Workshop you get:',
      starterHeading: 'Everything in free, plus:',
      premiumHeading: 'Everything in starter, plus:'
    },
    faq: {
      pricing: 'Pricing FAQ',
      question1: 'Q. What credit cards are available?',
      answer1:
        'For Workshop, VISA, MasterCard, American Express, JCB are available.',
      question2: 'Q. Do you correspond to bill payment?',
      answer2:
        'In the case of Ask plan, we can deal with it. Please contact us if you wish. (In the case of monthly payment, we have received a separate invoice issue fee.)',
      question3: 'Q. Can I change the plan even during the contract term?',
      answer3:
        'Yes. You can change the plan at any time and immediately use it in the plan after change. The price is calculated on the basis of the daily dividend and will not be charged in duplicate with the previous payment.',
      question4:
        'Q. Is there a refund when canceling in the middle of the contract period (change to free plan)?',
      answer4: 'I\'m sorry. We do not support refunds.',
      question5: 'Q. Is it possible to exchange contracts?',
      answer5:
        'Workshop is used with agreement to the Terms of Use and Privacy Policy, and we have not concluded individual NDA (Confidentiality Agreement) or outsourcing agreement etc. Please contact us if there are unavoidable circumstances.'
    },
    registration: {
      emailRegistered: 'This email is already registered',
      noAccount:
        'You registered as a participants! Please create the new account with that!',
      accountExists: 'You registered as a participants!'
    },
    DomainFVliteNavigation: {
      create: 'Create a new Lite FreshVoice domain',
      news: 'Edit the news section in Lite FreshVoice',
      problemReport: "Problem reports"
    },
    DomainWebinarNavigation: {
      create: 'Create a new webinar domain',
      news: 'Edit the news section in FreshVoice Webinar',
      dd_news: 'Edit the news section in DD'
    },
    billings: {
      type: 'Type',
      date: 'Date',
      description: 'Description',
      amount: 'Amount',
      downloadInvoice: 'Download Invoice',
      downloadReceipt: 'Download Receipt',
    },
    manageIpAddress: {
      heading: 'Whitelisted Ip Addresses',
      invalidIps: 'Some of IPs are invalid, please correct them.'
    },
    CreateDomainLabel: {
      enableWebinarMode: 'Enable webinar mode',
      enableConferenceMode: 'Enable Conference mode',
      enableIPAddressFilter: 'Enable IP address restrictions',
      planChangesRequired: 'You cannot use the same plan for upgrading or downgrading.',
      downgradeMesage: 'To downgrade to this plan you will need to delete the room or account.',
      coronaCampaign: 'Campaign',
      back: 'Back',
      confirm: 'Confirm',
      domainExists: 'Domain exists, please enter new domain',
      creditPayment: 'Credit Payment',
      expireMode: 'Expiration date ON',
      validMode: 'Enabled (forced)',
      invalidMode: 'Invalid (forced)',
      trial: 'Trial',
      thisAgreement: 'Agreement',
      maxLettersDomain: 'Domain must not be more than 39 characters',
      minLettersDomain: 'Domain must be at least of 3 characters',
      invalidDomain: 'Please enter only single-byte lowercase alphanumeric characters and hyphens.',
      completed: 'Completed',
      sentInformation: 'The input information is successfuly sent',
      confirmationInformation: 'As Confirmation, we sent the verification message to your email address. If you will not receive it,  please contact us from our freshvoice customer form. ',
      iAgreeText: 'I agree to the following terms and conditions.',
      inputConfirmation: 'Input Confirmaion',
      checkInformation: 'Please check you input information',
      idNumbers: 'ID Numbers',
      roomNumbers: 'Room Numbers',
      price: 'Price',
      payByInvoiceText: 'click here if you want to pay by invoice',
      transactionLawText: 'Notes on Specified Commercial Transaction Law.',
      proceedToConfirm: 'Proceed to confirm input contents',
      securityCode: 'Security code',
      expirationDate: 'Expiration Date',
      ccExpirationDate: 'Expiration Date',
      cardNumber: 'Card number',
      ccInfo: 'Credit card information',
      referTo: 'Please refer to the',
      here: 'here',
      priceListDetails: 'Price list details',
      monthlyCost: 'Monthly cost',
      taxIncluded: '(Tax included)',
      initialPrice: 'Initial cost',
      domainCompany: 'Domain name for your company',
      room: 'Room',
      desiredAccounts: 'Desired ID number',
      desiredRooms: 'Desired number of rooms',
      required: 'Required',
      desiredPlan: 'Desired plan',
      applicationForm: 'Application form',
      thanksForUsingTrial: 'Thank you for using the 2-week free trial.',
      continueService: 'Please fill out the form below to continue the service.',
      questionnaireHeading: "We would love to hear your thoughts on using LiteFreshVoice.",
      questionnaireHeading1: '*The content of your answers will be used only as important materials for improving our services.',
      answerSurvey: "Answer the survey",
      FVDomainType: 'FvDomain Type',
      submit: 'Submit',
      companyName: 'Company Name',
      maxConnNum: 'Maximum Connections Number',
      contract: 'Contract',
      mode: 'Mode',
      expires: 'Expires',
      maxRoomNumUser: 'Max Room Number Per User',
      maxAccountAmountNum: 'Max Account Amount Number',
      FVDomainsName: 'FV Domains Name',
      videoEndURL: 'Video End URL',
      videoLogoRemove: 'Video Logo Remove',
      videoDirectMobile: 'Video Direct Mobile',
      adminGuestURL: 'Admin Guest URL',
      videoInviteModalRemove: 'Video Invite Modal Remove',
      videoWebrtcStatsRemove: 'Video Webrtc Stats Remove',
      videoWebrtcStatsLogEnable: 'Video Webrtc Stats Log Enable',
      videoFullscreenRemove: 'Video Fullscreen Remove',
      backcamera: 'Mobile Default Backcamera Enable',
      textChat: 'Video Text Chat Remove',
      colorBottomBtn: 'Video Color Bottom Action Button',
      colorEndCallBtn: 'Video Color End Call Button',
      videoGoogle: 'Video Google Analytics',
      audioGuestMode: 'Video Audio Guest Mode',
      upperVideoSize: 'Video Mobile Upper Video View Size',
      remoteVideo: 'Video Remote Audio Remove',
      notes: 'Notes',
      newadminUser: 'The url link of creating the new admin user',
      newguestUser: 'The url link of creating the new guest user',
      newguesttrialUser: 'The url link of creating the new trial guest user in new landing page',
      deleteDomain: 'Delete this domain',
      videoDisplayNameremove: 'Video Display Remove Name',
      status: 'Status',
      createBtn: 'Create the new domain',
      updateBtn: 'Update this domain',
      formcreateTitle: 'Create Domain',
      formupdateTitle: 'Update Domain',
      recordingRemoveVideo: 'Video Local Recording Remove',
      settingsRemoveVideo: 'Video Settings Remove',
      resetBtn: 'Reset',
      enableFirefox: 'Video Enable Firefox',
      enableMirror: 'Video Mirror Enable',
      headerLetfColor: 'Header Left Color',
      headerRightColor: 'Header Right Color',
      Password: 'Add Password',
      fvliteRole: 'Lite FreshVoice Role',
      fvliteAutoTrial: 'Lite FreshVoice Auto Trial',
      limitRedirectUrl: 'Lite FreshVoice Auto Trial Time Limit Redirect URL',
      webRtcStunServer: 'Web RTC Stun Server',
      webRtcStunServerPort: 'Web RTC Stun Server Port',
      webRtcTurnServer: 'Web RTC Turn Server',
      webRtcTurnServerPort: 'Web RTC Turn Server Port',
      webrtcForceTurn: 'Web RTC Force Turn',
      videoCodec: 'Video Codec',
      ID: 'ID',
      name: 'Name',
      email: 'Email',
      contractStatus: 'Contract Status',
      domainStatus: 'Domain Status',
      maxAccountNumber: 'Max Account Number',
      fvDomainsName: 'FV domains name',
      action: 'Action',
      totalUsers: 'Total Number Of Users',
      expiryDays: 'Expiry Days',
      maxAccountNoUser: 'Maximum Account Number',
      marketingAutomationEmail: 'Marketing Automation Email',
      trailExpiredEmailBtn: '[USER] Trial expired email',
      trailExpiredMAEmailBtn: '[MA] Trial expired email',
      MASignupEmailBtn: '[MA] SIGUNP EMAIL',
      pcFramerateIdeal: 'frameRate.ideal',
      pcFramerateMax: 'frameRate.max',
      pcVideoWidthMin: 'width.min',
      pcVideoWidthIdeal: 'width.ideal',
      pcVideoHeightMin: 'height.min',
      pcVideoHeightIdeal: 'height.ideal',
      mobileFramerateIdeal: 'frameRate.ideal',
      mobileFramerateMax: 'frameRate.max',
      mobileVideoWidthMin: 'width.min',
      mobileVideoWidthIdeal: 'width.ideal',
      mobileVideoHeightMin: 'height.min',
      mobileVideoHeightIdeal: 'height.ideal',
      hide: 'Hide',
      hiddenDomain: 'Hidden domain',
      unhide: 'Unhide',
      activeDomains: 'Active Domains'
    },
    createFVDomainError: {
      discription: 'Please enter within 300 characters'
    },
    user: {
      secondFailedCreditPayment: 'The credit card payment failed and domain is invalid. Please contact support',
      firstFailedCreditPayment: 'Credit payment failed. Please enter valid card information.',
      updateCard: 'Update Card',
      userList: 'User List',
      usersList: 'USER LIST',
      createUser: 'Create the new user',
      updateUser: 'Update User',
      successUser: 'User Created Successfully',
      successUserUpdate: 'User updated Successfully',
      name: 'Username',
      email: 'Email',
      password: 'Password',
      role: 'Role',
      add: 'Create new user',
      guest: 'guest',
      admin: 'admin',
      save: 'save',
      addLabel: 'Add User',
      notFoundUser: 'You have no users in your domain, please add some',
      deleteConfirm:'Do you really want to delete the user?',
    },
    PlanDetails: {
      companyName: 'Company Name',
      expiryDate: 'Expiration date',
      status: 'Status',
      maxNumberofAccounts: 'Maximum number of accounts',
      fvliteDomain: 'Lite FreshVoice Domain',
      maxNumberofRooms: 'Maximum number of rooms',
      expireDeadline: 'Expire deadline',
      trial: 'Trial',
      accountNumbers: 'Account numbers: {n}',
      numberOfRooms: 'Numbers of rooms: {n}'
    },
    trialPlanDialog: {
      onTrial: 'on trial',
      period: 'period : ',
      descriptionText: 'now on trial, you have to go to fill the application form to continue to use our service.',
      goToFormPage: 'Go to Application Form'
    },
    activityLogs: {
      webinar: 'Webinar mode',
      conference: 'Conference mode',
      mode: 'Mode',
      name: 'Name',
      event: 'Event',
      ip_address: 'IP Address',
      datetime: 'DateTime',
      noLogs: 'You have no logs recorded yet.',
      fetchingLogs: 'Fetching Activity Logs',
      room_name: 'Room Name',
      join_event: 'Join',
      leave_event: 'Leave',
      period: "Date",
      webinarMode: "Webinar",
      conferenceMode: "Conference",
      selectValidDate: "Set an End Date after the Start Date.",
      selectMode: "Select Conference/Webinar mode."
    },
    maintenance:{
      typeMaintenanceModeHint: 'Type `{string}`',
      maintenancePassword: 'Password for maintenance environment',
      settings: 'Maintenance Settings',
      messagePlaceholder: 'Maintenance Message',
      heading: 'Under Maintenance Now',
      dateTimeHeading: '[Maintenance Time]',
      dateTime: 'Friday 22: 00 ~ 24: 00',
      message1: 'This site is currently undergoing routine maintenance and upgrades, but will be back soon.',
      message2: 'Thank you for your patience and understanding.'
    },
    roomList:{
      roomName:"Room Name",
      password:"Password",
      locked:"Locked Room",
      confrenece: "Conference mode",
      invitationUrl: "Invitation URL",
      hostUrl:"Host URL",
      enterRoom: "Enter Room",
      webinarMode:"Webinar mode",
      participantUrl: "Participant URL",
      lectureUrl: "Lecturer URL",
      delete:"Delete room",
      invitationEmail: "Invitation email",
      edit: "Edit",
      createNewRoom: "Create a new room",
      questionnaire: "Questionnaire",
      roomExpiration: "Room Expiration",
      noRoom: "No rooms found!",
      fetchingRooms: "Fetching rooms...",
      copyUrl: "Copy URL",
      other: "Other",
      options: "Options",
      microphoneControl: "Microphone Control",
      cameraControl: "Camera Control",
      screenShareControl: "Screen Share Control",
      recordingControl: "Recording Control",
      muteMicrophone: "Mute participant's microphone on entry",
      muteCamera: "Mute participant's camera on entry",
      disallowScreenShare: "Disallow screen share from participants",
      disallowRecording: "Disallow recording from participants",
      roomCreated: "Room has been registered successfully.",
      roomUpdated: "Room has been updated  successfully.",
      sendInvitation: "Send a invitation Email",
      googleCalendar: "ADD SCHEDULE TO GOOGLE CALENDAR",
    },
    questionnaire: {
      deleteQuestionnaire: "Delete Questionnaire",
      title: "Title",
      question: "Question",
      options: "Options",
      anonymous: "Anonymous",
      yes: "Yes",
      no: "No",
      allowed: "Allowed",
      notAllowed: "Not allowed",
      result: "Result",
      select: "Select",
      one: "Only one",
      multiple: "Multiple",
      addQuestionnaire: "Add questionnaire",
      option1: "Option 1",
      option2: "Option 2",
      option3: "Option 3",
      titlePlaceholder: "ex. Favorite Animal",
      questionPlaceholder: "ex. What is your favorite animal?",
      createNew: "Register a new Questionnaire",
      template: "Template",
      addNewOption: "Add new Option",
      freeDescription: "Free description",
      templateHint: "By registering a template, you can easily create a questionnaire with the same content.",
      questionnaireResult: "Questionnaire Result",
      responder: "Responder",
      number: "Number",
      csvExport: "CSV Export",
      fetchingQuestionnaire: "Fetching questionnaires...",
      noQuestionnaireFound: "No questionnaire found!",
      fetchingTemplates: "Fetching templates...",
      noTemplates: "No templates found!",
      addOptions: "Add Options.",
      roomSelectError: "Select a Room.",
      titleError: "Add title to this Questionnaire.",
      questionError: "Add Question.",
      totalAnswers: "Total : {number} person's",
      deleted: "Deleted",
      questionnaireList: "Questionnaire list",
      registerAt: "Registered At",
      sentAt: "Sent at",
      reRegister: "Re-register",
      resultExpired: 'This result has been expired.',
      addOptionPlaceholder: "Enter answer",
      selectDescriptionOrOptionError: "Please either allow free description or add options.",
    }, helper: {
        conference: {
          invitationUrl: "Copy Invitation URL.",
          hostUrl: "Copy Host URL.",
          invitationEmail: "Send an invitation email.",
          enterRoom: 'You can join as a "host" by clicking the "Join The Room" button of the room you want to join.\n\nIf you want to join the room as an "invitee", copy the "invitation URL" and join from the browser.',
          edit: 'You can set and edit "Room name", "Password" and "Locked Room".'
        }, webinar: {
          participantUrl: "Copy participants URL.",
          instructorUrl: "Copy instructor URL.",
          invitationEmail: "Send an invitation email.",
          enterRoom: 'You can join as a "Lecturer" by clicking the "Join The Room" of the room you want to join.\n\nIf you want to join the room as a "Participant", copy the "Participant URL" and join from the browser.',
          edit: 'You can set and edit "Room Name", "Password", "Locked Room", and "Questionnaire".'
        }, conferenceRoom: {
          name: `Create Room.\n
          Only "lowercase alphabet", "number" and "hyphen" can be used for the room name. Please note that you can't set the same room name as in webinar mode.`,
          password: `Set any password.\nIf you do not want to set a password, leave it blank and click "Save".\n
          If you have set a password, you’ll be prompted to enter the password after clicking "Join Room" on the entry confirmation screen.`,
          locked: `Host side: If you turn on "Locked Room", you can choose whether or not to enter the room when the invitee tries to enter the room.
          \nInvite: If you turn on "Locked Room", you'll not be able to enter the room without the permission of the host.`,
          roomExpiration: `You can set the room entry time.\nHost can enter the room at any time, but guest can only enter during the set time.`,
          startTime: "Start time",
          endTime: 'End time'
        }, webinarRoom: {
          name: `Enter the room name you want to create.
          Only "lowercase alphabet", "number" and "hyphen" can be used for the room name.\n Please note that you can't set the same room name as in Conference mode.`,
          password: `Set any password.
          If you do not want to set a password, leave it blank and click "Save".\n
          If you have set a password, you'll be prompted to enter the password after clicking "Join Room" on the entry confirmation screen.`,
          locked: `Lecturer side: If you turn on "Locked Room", you can choose whether or not to enter the room when the invitee Participant to enter the room.\n
          Participant side: If you turn on "Locked Room", you'll not be able to enter the room without the permission of the Lecturer.`,
          questionnaire: `Turn on Questionnaire to create single-choice or multi-choice questionnaire.\n
          The questionnaire created here can be sent to participants during the webinar to collect answers.`
        }, roomExpiration: {
          beforeTimeError: "Invalid date, Please select the future date.",
          timeError: 'Select Time to save it.',
          endTimeBeforeStartError: "Invalid end date, end date cannot be before start date.",
          invalidDate: "Please select valid start and end date.",
        }
    }, transcriptions: {
      transcriptions: "Transcriptions",
      viewAll: "View All Transcriptions",
      startDate: "Start date",
      endDate: "End Date",
      textToSearch: "Text to search",
      search: "Search",
      clearSearch: "Clear search",
      room: "Room name",
      date: "Date",
      viewTranscription: "View Transcription",
      back: "Back",
      googleResult: "Google result",
      noTranscriptions: "No Transcriptions found!",
      noTranscriptionsFound: "No Transcriptions found!",
      createAndEdit: "Create and Edit Questionnaire",
      addToTemplate: "Add to Template",
      csvDownload: "CSV Download",
      searchResult: "Search result"
    }, emailAddressBook: {
      addNew: "Add new email address",
      editGroup: "Edit group",
      csvImport: "CSV import",
      name: "Name",
      email: "Email",
      role: "Role",
      group: "Group",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      name: "Name",
      emailAddress: "Email address",
      group: "Group",
      host: "Host",
      participant: "Participant",
      hostAndParticipant: "Host, Participant",
      addNewGroup: "Add new group",
      groupName: "Group name",
      sendInvitationEmail: "Send invitation email",
      to: "To",
      title: "Title",
      content: "Content",
      cancel: "Cancel",
      send: "Send",
      done: "Done",
      noUsers: "No users found!",
      noGroups: "No groups found!",
      searchUserName: "User name",
      noUserInAddressBook: "There is no user in address book.",
      sendInvitationByRole: "Please send Invitation mail per Roll.",
      selectEmailAddress: "Please select Email address from Address book",
      noAvailableGroup: "No available group.",
      selectRole: "Select a Roll to send invitation email.",
      addName: "Please add name.",
      addEmail: "Please add email address.",
      selectRoleError: "Please select atleast one role.",
      addEmailHint: "Add new email address to address book.",
      editGroupHint: "Group multiple users together. It helps to send Invitation email to the user in group all at once.",
      importCSVHint: "Add multiple email addresses all at once.",
      groupNamePlaceholder: "Group name",
      addGroupNameError: "Please enter group name.",
      csvUploadError: "CSV import has been failed. Please check file and try again later.",
      confirmRole: "Email address you selected will be removed, when you select different Roll. Are you sure to change Roll? ",
      invitationHistory: "Invitation email history",
      groupNameAlreadyUsed: "The same group name have already been used.",
      noResultFound: "No results found",
      csvDownload: "CSV File download",
      exportCSVHint: "You can download the template file for CSV import.",
      reselectRole: "Re-select Roll.",
      searchAddressBook: "Search User name or Email.",
      importAddressBookSuccess: "Email address has been added successfully.",
      emailAdded: "Email has been added successfully.",
      likeToSendInvitation: "If you would like to send an invitation email, select a Roll. ",
      addressSaved: "Address has been added successfully."
    }, invitations: {
      date: "Date",
      invitedUsers: "Invited users",
      resend: "Re-send",
      noInvitationFound: "No invitations found.",
      fetchingInvitations: "Fetching invitations..."
    }, problemReport: {
      domainName: "Domain name/room name",
      date: "Date and Time",
      problemType: "Problem type",
      details: "Details",
      description: "Descriptions",
      downloadAttachment: "Display attached file",
      fetchingReport: "レポートを照合中",
      noReport: "レポートがありません"
    }
  },
  ja: {
    activityLogs: {
      webinar: 'ウェビナーモード',
      conference: '会議モード',
      mode: 'モード',
      name: '参加者名',
      event: 'イベント',
      ip_address: 'IPアドレス',
      datetime: '日時',
      noLogs: 'ログはまだ記録されていません。',
      fetchingLogs: 'アクティビティログの取得',
      room_name: '部屋名',
      join_event: '入室',
      leave_event: '退出',
      period: '表示期間',
      webinarMode: "ウェビナー",
      conferenceMode: "会議",
      selectValidDate: " 終了日は開始日よりも先の日付を設定してください。",
      selectMode: "会議/ウェビナーモードのどちらかを選択してください。"
    },
    login: {
      invalid_ip: 'お客様のネットワーク環境からではアクセス出来ません。 アクセス許可のあるネットワーク環境から再度アクセスしてください。アクセス出来るネットワーク環境が不明な場合は管理者にお問い合わせください。',
      heading: 'ウェビナーの開催をどうぞ',
      subHeading: '',
      forgotPassword: 'パスワードを忘れました',
      remember: 'ログインを保存',
      passwordLable: 'パスワード',
      emailLable: 'Eメールアドレス',
      requiredField: '入力してください',
      buttonLabel: 'ログイン',
      invalidPassword: 'Eメールまたはパスワードが正しくありません',
      noUser: 'ユーザーが見つかりません。',
      emailNotFound: 'Emailが見つかりません。',
      title: '2秒で繋がるWeb会議システム Lite FreshVoice',
      maxAttemptExceed: 'ログイン制限の最大数を超えています。5分後に再試行してください。',
      fetching: "取得しています"
    },
    footerMenu: {
      about:
        '<a class="link white" href="https://www.anets.co.jp/company/">About Us</a>',
      terms:
        '<a class="link black" href="https://workshop-live.com/term-jp.html">利用規約</a>',
      policy:
        '<a class="link black" href="https://workshop-live.com/privacy-jp.html">プライバシーポリシー</a>',
      developedBy: 'created by '
    },
    loggedOutNavigation: {
      home: 'ホーム',
      register: '新規アカウント作成'
    },
    roomRecordings: {
      room_name: '部屋名\n(モード)',
      started_at: '開始',
      ended_at: '終了',
      user_started: 'ユーザー',
      file: '録画ファイル',
      download: 'ダウンロード',
      fetchingRecordings: '録音の取得',
      noRecordings: '録音なし',
      duration: '録画時間',
      hours: '時間',
      minutes: '分',
      seconds: '秒',
      confirmation:'削除しますか?',
      mixedVideo:'合成映像',
      play: '再生',
      recordingTranscriptionSearch: "動画テキスト検索",
      videoDownload: "録画映像\nダウンロード",
      transcription: "動画テキスト",
      transcriptionDownload: "テキストCSV\nダウンロード",
      delete: "削除",
      withSubtitle: "字幕あり",
      withoutSubtitle: "字幕なし"
    },
    loggedInNavigation: {
      IPAddresses: 'IPアドレス制限',
      activityLogs: "入退室ログ",
      emailAddressBook: "アドレス帳",
      roomRecordings: "クラウド録画",
      lockRoom: "部屋のロック",
      passwordPlaceholder: 'パスワードを入力',
      managePlans: 'プラン',
      adminDashboard: '管理者用ダッシュボード',
      guestDashboard: 'ゲスト用ダッシュボード',
      roleAdmin: '管理者',
      roleGuest: '参加者',
      contacts: 'アドレス帳',
      settings: '設定',
      recordings: 'ローカル録画映像',
      seminars: 'セミナー',
      rooms: 'セミナー',
      upgrade: 'アップグレード',
      new: 'セミナー作成',
      modalHeader: 'アップグレード',
      upgradeConfirmation: 'アドミンへアップグレードしますか?',
      upgradeModalBody: '月2回まで、無料でワークショップを開催することができます。',
      cancel: 'キャンセル',
      gotoAdmin: 'アドミンダッシュボードへ',
      gotoGuest: 'ゲストダッシュボードへ',
      logout: 'ログアウト',
      adminster: 'ゲストはセミナー開催できません',
      manual: 'マニュアル',
      notice: 'お知らせ',
      fvlite_room: '会議モード',
      webinar_rooms: 'ウェビナーモード',
      createRoom: '部屋作成',
      createEditRoom: "新規部屋の作成・編集",
      enterRoom: '会議モード：入室',
      roomPlaceholder: '部屋の名前を入力してください',
      copyGuestUrl: 'ゲストのURLをコピーする',
      copyHostUrl: '会議モード：ホストURLコピー',
      copyUrl: '会議モード：招待URLコピー',
      deleteRoom: '削除する',
      deleteRoomMessage: '本当に部屋を削除しますか?',
      deleteConfirmation: '現在利用中のユーザーがいますが、本当にこの部屋を削除しますか？',
      urlCopy: '会議モードの招待URLがコピーされました',
      hostUrlCopy: '会議モードのホストURLがコピーされました',
      roomNameLength: '部屋名には最大20文字を含める必要があります',
      copyWebinarUrl: 'ウェビナーモード： 参加者URLコピー',
      copyWebinarPublisherUrl: 'ウェビナー モード：講師URLコピー',
      enterWebinarRoom: 'ウェビナーモード：入室',
      webinarUrlCopiedMessage: 'ウェビナーモードの参加者URLがコピーされました',
      webinarPublisherUrlCopiedMessage: 'ウェビナーモードの講師URLがコピーされました',
    },
    seminar: {
      registration: '参加者として登録',
      beginsIn: '開催時刻は',
      register: '参加者の登録画面へ行く',
      guests: '人',
      open: 'セミナー画面へ行く',
      upcoming: '未開催',
      previous: '開催済み',
      deleteSeminar: '削除',
      declineInvite: '参加拒否',
      acceptInvite: '参加登録',
      openSeminar: 'セミナー画面',
      deleteModalHeading: 'セミナーを削除しますか？',
      deleteConfirm: {
        sure: '本当に削除しますか？ ',
        seminar: ' が削除されます。',
        guestNumbers: '人招待しています'
      },
      deleteButtonLabel: '削除',
      delMessage: 'セミナーが削除されました',
      schedule: 'セミナー開催日時',
      scheduleUpdated: '開催日時が更新されました',
      date: '日付',
      time: '時刻',
      save: '保存',
      notScheduled: 'セミナー開催日時が設定されていません',
      dateNot: 'セミナー開催日時を設定されていません',
      scheduleNext: 'セミナー開催日時を設定してください',
      createNew: 'セミナー作成',
      seminarName: 'セミナーの名前',
      on: 'ON',
      off: 'OFF',
      record: 'セミナー映像を録画',
      create: '作成',
      mobile: 'ディスカッションモード',
      hour: "時",
      min: "分"
    },
    seminarActions: {
      members: '人',
      select: '選択済み',
      selectList: '選択',
      tabs: {
        details: '詳細',
        schedule: '開催日時',
        invite: '参加者',
        recording: '録画映像',
        settings: '設定'
      },
      name: '名前',
      description: '説明',
      noDescription: '説明がありません',
      addPassword: 'パスワード',
      saveDetails: '保存',
      clear: 'クリア',
      removedMessage: ' 削除済み',
      addParticipant: '参加者追加',
      previewEmail: '[ユーザ用]トライアルサインアップメール',
      import: 'インポート',
      invite: '参加者の招待と管理',
      inviteSubheading: '手動で入力、アドレス帳のインポートができます',
      tableHeading: {
        guests: '名前',
        email: 'Eメールアドレス',
        user: '状態/役割'
      },
      tableOptions: {
        add: '追加',
        import: 'インポート',
        sendAll: 'すべての参加者に招待メールを送信する',
        removeAll: 'すべての参加者を削除する'
      },
      sentEmailMessage: 'Sent email invite to ',
      participants: ' 参加者',
      multipleRemovedMessage: ' participants removed',
      selected: ' 人選択',
      singleRemoved: ' Removed',
      send: '招待メールを送信する',
      remove: '削除する',
      tooltipInvite: '招待メール送信',
      tooltipRemove: '削除',
      noParticipants: '参加者はいません。追加してください。',
      removeModal: {
        heading: 'Remove ',
        body: '本当に削除しますか？ ',
        seminar: '**'
      },
      dismiss: '閉じる'
    },
    inviteModal: {
      invited: ' invited to seminar',
      inviteParticipant: '参加者の追加',
      name: '名前',
      student: '受講者',
      teacher: 'プレゼンター',
      facilitator: 'アシスタント',
      invite: 'リストに追加する',
      listWith: ' lists with ',
      imported: ' contacts imported',
      shareToImport: 'アドレス帳から選択',
      listLelected: ' つ選択中',
      membersSelected: ' 人追加されます',
      inviteAll: 'すべての参加者(',
      participantToSeminar: ' 人)へ招待メールを送りますか?',
      noParticipants: 'No participants to import',
      sureNotify: 'Are you sure you want to notify and INVITE ALL ',
      all: 'invite all',
      sentInvite: 'Sent invite to ALL ',
      participants: ' Participants',
      deletedAllMessage: 'All Participants removed from seminar',
      sureRemoveAll: 'すべての参加者を削除します。この操作は取り消せません。',
      removeAll: 'remove all',
      recording: {
        date: '日付',
        name: 'ユーザ名',
        size: 'ファイルサイズ',
        duration: '長さ',
        download: 'ダウンロード',
        play: '再生',
        404: '録画映像はありません',
      },
      settings: {
        global: '設定 for ',
        timezone: 'タイムゾーン',
        language: '使用言語',
        bitrate: 'ビットレート',
        videoCodec: '映像コーデック',
        turn: 'Turn Serverの強制'
      }
    },
    previewModal: {
      subject: '件名',
      save: '保存する',
      default: 'デフォルトに戻す',
      body: '本体',
      close: '閉じる',
      success: 'メールコンテンツが正常に更新されました'
    },
    forgotPassword: {
      sent: '送信完了',
      sendAgain: ' ',
      successLine1: 'パスワード設定リンクを送信しました。',
      successLine2: 'メールがしばらく経っても届かない場合は、迷惑メールフォルダをチェックしてください。',
      checkSpam: ' ',
      resetByEMail: 'パスワードの再設定をEmailで行います。',
      buttonLabel: '送信'
    },
    signUp: {
      heading: '新規アカウント作成',
      doneHeading: '作成に成功しました。',
      passwordError: {
        short: '6文字以上で設定してください。',
        alphaNumeric: '数字とアルファベットの両方を1文字以上使用してください。',
        dontMatch: 'パスワードが一致しません。',
        long: '20文字以内にする必要があります',
        required: 'パスワードが必要です'
      },
      emailError: 'Emailの形式が正しくありません。',
      admin: 'admin',
      guest: 'guest',
      agree:
        '本サービスのアカウントを作成することにより,次の規約に同意したものとみなされます。',
      and: 'と',
      confirmPasswordLabel: 'パスワードの確認',
      emailTaken: 'このEmailは既に利用されています。',
      createAccount: 'アカウントを作成する',
      usernameLabel: 'ユーザ名',
      phoneNumeric: '電話番号には数字を含める必要があります',
      phoneValid: 'ハイフンなしで有効な電話番号を入力して下さい',
      phoneLabel: '電話番号',
      companyLabel: '会社名',
      trialTitle: 'の無料トライアル',
      trialDays: '14日間',
      startTrial: '下記ボタンをクリックすると使い方を記載したメールが届きます。',
      userplaceholder: '山田'
    },
    signupComplete: {
      hi: 'こんにちは',
      thanks: ' ',
      activate: '確認のメールを送りました。ご確認ください。',
      redirect: '自動でトップ画面へ戻ります。',
      thanksActivate: 'Thanks for Account Activation',
      expiredHeading: 'Expired URL',
      expiredText: '無効なURLへアクセスしました。',
      ActivationText: 'アカウントのアクィベーションに成功しました。ログインして、セミナーの参加や作成をしてください。',
      resetSuccessfullMessage: 'パスワードの更新に成功しました。新しいパスワードでログインすることができます。',
      successChangeEmail: 'Success for Changing Email Address',
      changeEmailSuccessfullMessage:
        'Emailアドレスの変更に成功しました。新しいEmailアドレスでログインできます。'
    },
    seminars: {
      emptyRoom: '表示可能なセミナーなし'
    },
    contacts: {
      genToken: 'APIトークンを生成する',
      revokeToken: 'APIトークンを取り消す',
      copyApiToken: 'APIトークンをコピーする',
      csvImport: 'CSV インポート',
      importCsv: ' CSV Fileをインポートする',
      supportedFormat: '対応フォーマット',
      chooseCsv: 'ファイルをここに置いてください。もしくはクリックしてください。',
      listName: 'アドレス帳の名前',
      create: '新規リスト作成',
      list: 'アドレス帳',
      edit: '名前の編集',
      delete: '削除',
      add: '追加',
      role: '役割',
      selected: ' 人選択',
      remove: '削除する',
      removed: ' ** ',
      tooltipEdit: '編集',
      tooltipRemove: '削除',
      userEdited: '更新しました。',
      userAdded: '追加しました。',
      name: '名前',
      save: '保存',
      addLabel: '作成',
      editLabel: '編集',
      deleteList: 'アドレス帳の削除',
      sureDelete: 'このアドレス帳を削除しますか？この操作は取り消しできません。'
    },
    settings: {
      account: 'アカウント設定',
      billing: '契約情報',
      unlimited: '無制限',
      picMessage: 'Picture updated',
      userType: '現在のプラン',
      saved: '保存完了',
      confirmDelete: 'アカウント削除の確定',
      deleteAccount: 'アカウント削除',
      typeMessage: {
        type: '確認のために、',
        accountName: ' と入力してください。',
        delete: 'DELETE'
      },
      sureDelete: 'アカウントの削除を行いますか？削除すると、支払った代金の返金はされません。また、アカウントの復元は対応しておりません。',
      deleteMessage: ' ',
      deleteButtonLabel: 'アカウント削除',
      updateEmail: '確認のメールをチェックしてください',
      emailAlreadyGot: 'このEmailは既に利用されています'
    },
    picture: {
      take: 'プロフィール写真の撮影',
      upload: 'プロフィール写真のアップロード',
      picture: ' ',
      dropImage: '画像ファイルのドラッグ&ドロップ、または画像ファイルの選択をしてください。',
      confirm: '確定',
      takePic: '撮影'
    },
    plan: {
      failedCount: '決済失敗回数',
      failedDate: '決済失敗日',
      changePlan: 'プランの変更',
      serviceEndDate: 'サービス終了日',
      nextBillingDate: '次の請求日',
      moveOn: '進む',
      successChangedPlan: 'プラン変更に成功しました。',
      updatingPlan: 'プランを更新しています...',
      installless: 'インストールレス',
      expired: '試用期限切れ',
      trialEndsIn: '日後にトライアル期間が終了します',
      premium: 'プレミアム',
      trialPeriod: '2週間のトライアル',
      initialPrice: '初期価格',
      totalPrice: '合計金額',
      yen: '円',
      yourPlan: '現在のプラン',
      plan: ' 予定',
      enjoyBenefits: '無料プランでは次の利用制約がございます。',
      seminarsMonth: 'セミナー開催の回数(/月)',
      concurrentSeminars: '同時開催の回数(/月)',
      maxParticipants: '最大参加者数(/人)',
      recordingStorage: '録画容量',
      upgradeAccess: 'なし',
      enjoyMore: '利用制約を解除するにはプランのアップグレードが必要です。',
      contactUs: 'カスタマイズが必要な場合や同時開催数を増やしたい場合はお問い合わせください。Email: nakajima@anets.co.jp',
      mangePlan: 'プランの詳細',
      currentPlan: '現在のプラン',
      backToFree: 'プランの解約をする',
      upgrade: '選択',
      upgradeFailed: 'アップグレードが失敗しました。',
      paymentFailed: '決済が失敗しました。もう一度トライしてください。',
      close: '**',
      changing: 'プランを変更しますか?',
      noRefund: ' ',
      sure: ' ',
      upgradeTo: ' ',
      switchBack: '**',
      warning: 'フリープランへ変更します。既にお支払い頂いた代金の返金は致しかねます。ご了承ください。'
    },
    mangePlan: {
      ccInfo: '現在のクレジットカード情報',
      expired: '有効期限',
      paymentHistory: '支払い履歴',
      settings: '設定',
      manage: 'プランの詳細',
      heading: 'お客様のニーズにあったプランをお選び下さい。お支払い方法はクレジット決済にのみ対応しております。',
      monthly: '月々支払い',
      yearly: '年間一括払い 20% OFF',
      month: '月',
      year: '年',
      updateCard: '更新',
      updateCreditCard: 'クレジットカード情報の更新',
      FAQ: '料金プランに関する質問'
    },
    planFeatures: {
      feature1: '月3回のセミナー開催',
      featureNotFree1: '月3回のセミナー開催',
      tooltip1: '１月当たりに最大で開催できるセミナー数を表しています。',
      feature2: 'ディスカッションモード',
      tooltip2:
        '参加者をテーブルごとに割り当て、ディスカッションさせることができます。また、プレゼンターとアシスタントはテーブルごとの音声を聞いたり、ディスカッションに参加することができます。',
      feature3: {
        upTo: '最大 ',
        participants: ' 人の参加'
      },
      tooltip3: '1セミナー当たりの最大参加者数です。',
      feature4: 'テキストチャット',
      tooltip4: 'セミナー中にテキストによるチャットが可能です。',
      feature5: 'アドレス帳管理',
      tooltip5: 'アドレス帳は新しいセミナーの参加者を追加する際に便利です。',
      feature6: '同時開催数 1',
      tooltip6: '同時に開催できるセミナーの上限数です。複数のセミナーを同時開催した場合はお問いあわせください。',
      feature7: 'GB 録画ストレージ',
      tooltip7: '録画映像のストレージ容量です。これを超える場合は録画機能が働きません。',
      feature8: 'Emailサポート',
      tooltip8: '営業時間中( 9:00 ~ 17:00 ) にEmailによる使い方やご不明な点などのサポートを行います。'
    },
    planHeading: {
      per: '/  ',
      zero: '無料!',
      monthly: '年間一括払いで ¥240,000 ( 1月当たり ¥20,000 )',
      yearly: '年間一括払いで ¥720,000 ( 1月当たり ¥60,000 )',
      freeHeading: 'お試しにご利用ください。',
      starterHeading: ' ',
      premiumHeading: ' '
    },
    faq: {
      pricing: '料金プランに関する質問',
      question1: 'Q. 利用可能なクレジットカードを教えてください。',
      answer1: 'Workshop ではVISA、MasterCard、American Express、JCBが利用可能です。',
      question2: 'Q. 請求書払いには対応していますか？',
      answer2:
        'カスタマイズが必要な場合または同時開催数を増やす場合は利用可能です。ご希望の場合はお問い合わせください。（月払いの場合、別途請求書発行手数料をいただいております。）',
      question3: 'Q. 契約期間の途中でもプランの変更はできますか？',
      answer3:
        'はい。プランはいつでも変更でき、すぐに変更後のプランにてご利用いただけます。料金は日割りした差額が計算され、前回の支払分と重複して請求されることはありません。',
      question4: 'Q. 契約期間の途中で解約した場合に払い戻しはありますか？また、どうやって解約できますか？',
      answer4: '申し訳ございません。払い戻しには対応しておりません。解約はフリープランへ変更することによりできます。',
      question5: 'Q. 契約書を取り交わすことはできますか？',
      answer5:
        'Workshop では 利用規約 およびプライバシーポリシーに同意いただいてのご利用とさせていただいており、個別の NDA（機密保持契約書）や、業務委託契約書等の締結は行っておりません。やむを得ない事情がある場合はお問い合わせください。'
    },
    registration: {
      emailRegistered: '既に参加者として登録されています。',
      noAccount: '登録が完了しました! アカウントを作成してください！',
      accountExists: '参加者としての登録が完了しました!'
    },
    DomainNavigation: {
      create: 'ウェビナードメインの新規作成',
      news: 'Lite FreshVoice お知らせの編集',
    },
    DomainWebinarNavigation: {
      create: 'ウェビナードメインの新規作成 ',
      news: 'FreshVoice Webinar お知らせの編集',
      dd_news: 'DD お知らせの編集'
    },
    DomainFVliteNavigation: {
      create: 'ウェビナードメインの新規作成',
      news: 'Lite FreshVoice お知らせの編集',
      problemReport: "問題レポート"
    },
    billings: {
      type: 'タイプ',
      date: '日付',
      description: '説明',
      amount: '値段(円)',
      downloadInvoice: '請求書をダウンロードする',
      downloadReceipt: '領収書をダウンロード',
    },
    manageIpAddress: {
      heading: 'ホワイトリストに登録されたIPアドレス',
      invalidIps: '一部のIPが無効です。修正してください。'
    },
    CreateDomainLabel: {
      enableWebinarMode: 'ウェビナーモードを有効にする',
      enableConferenceMode: '会議モードを有効にする',
      enableIPAddressFilter: 'IPアドレス制限を有効化する',
      planChangesRequired: '同一プランへの変更はできません',
      downgradeMesage: 'このプランへのダウングレードをするためには部屋またはアカウントの削除が必要になります。',
      coronaCampaign: 'キャンペーン',
      back: '戻る',
      confirm: '確定',
      domainExists: 'ドメインが存在します。別のドメインを選択してください。',
      creditPayment: 'クレジット支払い',
      expireMode: '有効期限ON',
      validMode: '有効(強制)',
      invalidMode: '無効(強制)',
      trial: 'トライアル',
      thisAgreement: '本契約',
      maxLettersDomain: 'ドメインは39文字以下にする必要があります',
      minLettersDomain: 'ドメインは少なくとも3文字でなければなりません',
      invalidDomain: '半角小文字の英数字とハイフンのみで入力してください。',
      completed: '完了しました',
      sentInformation: '入力情報が正常に送信されました',
      confirmationInformation: '確認として、 確認メッセージをメールアドレスに送信しました。 受け取れない場合は、 freshvoiceのお客様フォームからお問い合わせください。',
      iAgreeText: '次の約款・利用規約への同意を行ます',
      inputConfirmation: '入力確認',
      checkInformation: '入力情報を確認してください',
      idNumbers: 'ID番号',
      roomNumbers: '部屋番号',
      price: '価格',
      payByInvoiceText: '請求書払いを希望するユーザーはこちらへ',
      transactionLawText: '特定商取引法に関する注意事項',
      proceedToConfirm: '入力内容の確認へ進む',
      securityCode: 'セキュリティーコード',
      ccExpirationDate: '有効期限',
      cardNumber: 'カード番号',
      ccInfo: 'クレジットカード情報',
      referTo: 'をご覧ください',
      here: 'こちら',
      priceListDetails: '価格表詳細は',
      monthlyCost: '月額費用',
      taxIncluded: '(税込)',
      initialPrice: '初期費用',
      domainCompany: '貴社用ドメイン名',
      room: '部屋',
      desiredAccounts: '希望ID数',
      desiredRooms: '希望部屋数',
      required: '必須',
      desiredPlan: '希望プラン',
      applicationForm: '申し込みフォーム',
      thanksForUsingTrial: 'このたびは２週間無料トライアルをご利用いただきまして誠にありがとうございました。',
      continueService: 'サービスを継続される場合は、下記フォームからお申し込みください。',
      questionnaireHeading: "LiteFreshVoiceのご使用感につきまして、ご意見をお聞かせいただけますと幸いです。",
      questionnaireHeading1: '※お答えいただいた内容につきましては、当社のサービス向上の大切な資料としてのみ利用させていただきます。',
      answerSurvey: "アンケートに回答する",
      FVDomainType: 'FvDomainタイプ',
      submit: '参加する',
      companyName: '会社名',
      maxConnNum: '最大接続数',
      contract: 'ドメイン契約状態',
      mode: 'ドメイン契約状態の設定',
      expires: '有効期限',
      maxRoomNumUser: 'ユーザの部屋の最大数',
      maxAccountAmountNum: '最大アカウント数',
      FVDomainsName: 'FVドメイン名',
      videoEndURL: '接続終了後のURL',
      videoLogoRemove: 'Lite FreshVoice ロゴ削除',
      videoDirectMobile: 'モバイルでの、直接ビデオ画面ジャンプ',
      adminGuestURL: 'ゲスト用URLの作成',
      videoInviteModalRemove: '初期の招待モーダル削除',
      videoWebrtcStatsRemove: 'WebRTC統計削除',
      videoWebrtcStatsLogEnable: 'WebRTCログ有効',
      videoFullscreenRemove: '相手映像フルスクリーンボタン削除',
      backcamera: 'デフォルトで、モバイルバックカメラ使用',
      textChat: 'テキストチャット機能削除',
      colorBottomBtn: '下部アクションボタンの色',
      colorEndCallBtn: '接続終了ボタンの色',
      videoGoogle: 'Google AnalyticsタグID',
      audioGuestMode: 'ビデオオーディオゲストモード',
      upperVideoSize: 'モバイル上部ビデオのサイズ',
      remoteVideo: '相手音声ON/OFFボタンの削除',
      notes: 'ノート',
      newadminUser: '新しい管理ユーザーを作成するURLリンク',
      newguestUser: '新しいゲストユーザーを作成するURLリンク',
      newguesttrialUser: '新しいトライアルゲストユーザーを作成するためのURLリンク',
      deleteDomain: 'このドメインを削除',
      videoDisplayNameremove: 'ビデオディスプレイ名を削除',
      status: 'ステータス',
      createBtn: '新規ドメインの作成',
      updateBtn: 'ドメインの更新',
      formcreateTitle: 'ドメインを作成する',
      formupdateTitle: 'ドメインの設定',
      recordingRemoveVideo: 'ビデオローカル録画削除',
      settingsRemoveVideo: 'ビデオ設定削除',
      resetBtn: 'リセット',
      enableFirefox: 'Firefoxをビデオ有効にする',
      enableMirror: 'ビデオミラー有効',
      headerLetfColor: 'ヘッダーの左の色',
      headerRightColor: 'ヘッダーの右の色',
      Password: 'パスワードを追加',
      fvliteRole: 'Lite FreshVoice ロール',
      fvliteAutoTrial: 'ユーザーアカウントの自動トライアル機能',
      limitRedirectUrl: '自動トライアル終了後のリダイレクトURL',
      webRtcStunServer: 'stunサーバー(turn.workshop.tokyo)',
      webRtcStunServerPort: 'stunポート(443)',
      webRtcTurnServer: 'turnサーバー(turn.workshop.tokyo)',
      webRtcTurnServerPort: 'turnポート(443)',
      webrtcForceTurn: 'turn強制(false)',
      ID: 'ID',
      name: '会社名',
      email: 'Eメール',
      contractStatus: '契約状態',
      domainStatus: 'ステータス',
      expirationDate: 'ドメイン有効期限',
      maxAccountNumber: '最大アカウント数',
      fvDomainsName: 'FVドメイン名',
      action: 'アクション',
      totalUsers: '総ユーザー数',
      expiryDays: 'ユーザーアカウントの有効期限(日数)',
      maxAccountNoUser: '最大ユーザー数',
      trailExpiredEmailBtn: '[ユーザ用] トライアル切れメール',
      trailExpiredMAEmailBtn: '[MA] トライアル切れメール',
      MASignupEmailBtn: '[MA] サインアップメール',
      marketingAutomationEmail: 'マーケティングオートメーションメール',
      pcFramerateIdeal: 'frameRate.ideal',
      pcFramerateMax: 'frameRate.max',
      pcVideoWidthMin: 'width.min',
      pcVideoWidthIdeal: 'width.ideal',
      pcVideoHeightMin: 'height.min',
      pcVideoHeightIdeal: 'height.ideal',
      mobileFramerateIdeal: 'frameRate.ideal',
      mobileFramerateMax: 'frameRate.max',
      mobileVideoWidthMin: 'width.min',
      mobileVideoWidthIdeal: 'width.ideal',
      mobileVideoHeightMin: 'height.min',
      mobileVideoHeightIdeal: 'height.ideal',
      hide: '非表示',
      hiddenDomain: '非表示リスト',
      unhide: '再表示',
      activeDomains: 'アクティブドメイン'
    },
    createFVDomainError: {
      discription: '300文字以内で入力してください'
    },
    user: {
      secondFailedCreditPayment: 'クレジットカードによる支払いが失敗し、ドメインが無効です。サポートに連絡してください ',
      firstFailedCreditPayment: 'クレジット決済に失敗しました。有効なカード情報を入力してください',
      updateCard: 'カードを更新する',
      userList: 'ユーザーリスト',
      usersList: 'ユーザーリスト',
      createUser: '新しいユーザーを作成する',
      updateUser: 'ユーザーを更新',
      successUser: 'ユーザーが正常に作成されました',
      successUserUpdate: 'ユーザーが更新されました',
      add: '新しいユーザーを作成',
      name: 'ユーザー名',
      email: 'メール',
      password: 'パスワード',
      role: '役割',
      guest: 'ゲスト',
      admin: '管理者',
      save: '保存する',
      addLabel: 'ユーザーを追加',
      notFoundUser: 'ドメインにユーザーがいません。いくつか追加してください',
      marketingAutomationEmail: 'マーケティングオートメーションメール',
      deleteConfirm:'本当にユーザーを削除しますか?'
    },
    PlanDetails: {
      companyName: '会社名',
      expiryDate: '有効期限',
      status: '状態',
      maxNumberofAccounts: 'アカウントの最大数',
      fvliteDomain: 'Lite FreshVoice ドメイン',
      maxNumberofRooms: '部屋の最大数',
      expireDeadline: '期限切れ',
      trial: 'トライアル',
      accountNumbers: 'アカウント数: {n}',
      numberOfRooms: '部屋数: {n}'
    },
    trialPlanDialog: {
      onTrial: '無料トライアル中',
      period: '期間 : ',
      descriptionText: '現在、無料トライアル体験中 になります。 サービスを継続される場合は お申し込みにお進みください',
      goToFormPage: '申し込みに進む'
    },
    maintenance:{
      typeMaintenanceModeHint: 'タイプ `{string}`',
      maintenancePassword: 'メンテナンス環境のパスワード',
      settings: 'メンテナンス設定',
      messagePlaceholder: 'メンテナンスメッセージ',
      heading: 'ただいまメンテナンス中です',
      dateTimeHeading: '【メンテナンス時間】',
      dateTime: '金曜日 22:00~24:00',
      message1: 'ご利用の皆様にはご迷惑をおかけし、申し訳ございません',
      message2: 'メンテナンス終了までしばらくお待ちください。',
    },
    roomList:{
      roomName:"部屋名",
      password:"パスワード",
      locked:"部屋のロック",
      confrenece: "会議モード",
      invitationUrl: "招待 URL",
      hostUrl:"ホスト URL",
      enterRoom: "入室",
      webinarMode:"ウェビナーモード",
      participantUrl: "参加者 URL",
      lectureUrl: "講師 URL",
      delete:"部屋を削除",
      invitationEmail: "招待メール",
      edit: "編集",
      createNewRoom: "新しい部屋を作成する",
      questionnaire: "アンケート",
      roomExpiration: "部屋の有効期限",
      noRoom: "部屋がありません",
      fetchingRooms: "フェッチングルーム...",
      copyUrl: "URLコピー",
      other: "その他",
      options: "詳細設定",
      microphoneControl: "マイク制御",
      cameraControl: "カメラ制御",
      screenShareControl: "画面共有制御",
      recordingControl: "録画制御",
      muteMicrophone: "入室時に参加者のマイクミュート",
      muteCamera: "入室時に参加者のカメラミュート",
      disallowScreenShare: "参加者からの画面共有を許可しない",
      disallowRecording: "参加者による録画を許可しない",
      roomCreated: "部屋が作成されました",
      roomUpdated: "部屋を更新しました。",
      sendInvitation: "招待メールを送る",
      googleCalendar: "Googleカレンダーに登録する",
    }, 
    questionnaire: {
      deleteQuestionnaire: "アンケートを削除する",
      title: "タイトル",
      question: "質問",
      options: "回答",
      anonymous: "匿名",
      result: "結果",
      yes: "はい",
      no: "いいえ",
      allowed: "有",
      notAllowed: "無",
      select: "選択肢",
      one: "１つのみ選択",
      multiple: "複数選択",
      addQuestionnaire: "アンケートを追加する",
      option1: "回答文１を入力",
      option2: "回答文２を入力",
      option3: "回答文３を入力",
      titlePlaceholder: "タイトルを入力",
      questionPlaceholder: "質問を入力",
      createNew: "アンケートを登録する",
      template: "テンプレート",
      addNewOption: "回答文を追加する",
      freeDescription: "自由記述",
      templateHint: "テンプレート登録すると、同じ内容のアンケートを簡単に作成できます。",
      questionnaireResult: "アンケート結果",
      responder: "回答者",
      number: "人数",
      csvExport: "CSVファイル出力",
      fetchingQuestionnaire: "アンケートを取得しています",
      noQuestionnaireFound: "アンケートが見つかりません",
      fetchingTemplates: "テンプレートを取得しています",
      noTemplates: "テンプレートが見つかりません",
      addOptions: "回答を入力してください",
      roomSelectError: "部屋を選択してください",
      titleError: "タイトルを入力してください",
      questionError: "質問を入力してください",
      totalAnswers: '回答者数：{number} 人',
      deleted: "削除済み",
      questionnaireList: "アンケート一覧",
      registerAt: "登録日時",
      sentAt: "送信日時",
      reRegister: "再登録",
      resultExpired: '有効期限が切れています。',
      addOptionPlaceholder: "回答を入力",
      selectDescriptionOrOptionError: "回答か自由記述のどちらかを設定してください",
    }, helper: {
        conference: {
          invitationUrl: "招待したい部屋の招待者向けURLをコピーできます。",
          hostUrl: "招待したい部屋のホスト向けURLをコピーできます。",
          invitationEmail: "招待したい部屋のホスト向けURLをコピーできます。",
          enterRoom: `入室したい部屋の「入室」ボタンをクリックすると「ホスト」として入室できます。\n「招待者」として入室する場合は「招待URL」をコピーして、ブラウザから入室してください。`,
          edit: '「部屋名」「パスワード」「部屋のロック」を設定・編集できます。'
        }, webinar: {
          participantUrl: "招待したい部屋の参加者向けURLをコピーできます。",
          instructorUrl: "招待したい部屋の講師者向けURLをコピーできます。",
          invitationEmail: "招待メールを送ることができます。",
          enterRoom: "入室したい部屋の「入室」ボタンをクリックすると「講師」として入室できます。\n「参加者」として入室する場合は「参加者URL」をコピーして、ブラウザから入室してください。",
          edit: "「部屋名」「パスワード」「部屋ロック」「アンケート」を設定・編集できます。"
        }, conferenceRoom: {
          name: `作成したい部屋名を入力します。\n部屋名は、「小文字アルファベット」「数字」「ハイフン」のみ使用できます。\nウェビナーモードと同じ部屋名は設定できませんのでご注意ください。`,
          password: `任意のパスワードを設定できます。\nパスワードを設定しない場合は空欄のまま「保存」をクリックします。\n
          パスワードを設定した場合、入室確認画面で「部屋に参加」をクリックした後にパスワードの入力を求めら れます。`,
          locked: `ホスト側:「部屋のロック」をオンにすると招待者が入室しようとした際に入室可否を選択できます。\n\n招待者側:「部屋のロック」をオンにすると入室する際にホストの許可がないと入室できません。`,
          roomExpiration: `部屋の入室時間を設定できます。\nホストはいつでも入室できますが、ゲストは設定された時間内のみ入室できます。`,
          startTime: "開始時刻",
          endTime: '終了時刻'
        }, webinarRoom: {
          name: `作成したい部屋名を入力します。\n部屋名は、「小文字アルファベット」「数字」「ハイフン」のみ使用できます。\n会議モードと同じ部屋名は設定できませんのでご注意ください。`,
          password: `任意のパスワードを設定できます。\nパスワードを設定しない場合は空欄のまま「保存」をクリックします。\n
          パスワードを設定した場合、入室確認画面で「部屋に参加」をクリックした後にパスワードの入力を求め られます。`,
          locked: `講師側:「部屋のロック」をオンにすると参加者が入室しようとした際に入室可否を選択できます。\n\n参加者側:「部屋のロック」をオンにすると入室する際に講師の許可がないと入室できません。`,
          questionnaire: `「アンケート」をオンにすると単一選択または複数選択のアンケートを作成できます。\n
          ここで作成したアンケートはウェビナー中に参加者に送信し、回答を集めることができます。`
        }, roomExpiration: {
          beforeTimeError: "先の日程を設定してください",
          timeError: '時間を設定してください',
          endTimeBeforeStartError: "開始日時よりも先の日時を設定してください",
          invalidDate: "開始日時と終了日時を設定してください",
        }
    }, transcriptions: {
      transcriptions: "動画テキスト検索",
      viewAll: "すべてのテキストを表示する",
      startDate: "開始日",
      endDate: "終了日",
      textToSearch: "検索する文字を入力",
      search: "検索",
      clearSearch: "クリア",
      room: "部屋名",
      date: "日時",
      viewTranscription: "テキストを表示する",
      back: "戻る",
      googleResult: "Googleの検索結果",
      noTranscriptions: "テキストは見つかりませんでした",
      noTranscriptionsFound: "検索条件に一致する結果が見つかりません",
      createAndEdit: "アンケートの新規作成・編集",
      addToTemplate: "テンプレート登録",
      csvDownload: "CSVダウンロード",
      searchResult: "検索結果"
    }, emailAddressBook: {
      addNew: "アドレスの登録",
      editGroup: "グループ編集",
      csvImport: "CSVインポート",
      name: "名前",
      email: "アドレス",
      role: "役割",
      group: "グループ",
      edit: "編集",
      save: "保存",
      cancel: "キャンセル",
      delete: "削除",
      name: "名前",
      emailAddress: "メールアドレス",
      group: "グループ",
      host: "ホスト",
      participant: "参加者",
      hostAndParticipant: "ホスト, 参加者",
      addNewGroup: "新規追加",
      groupName: "グループ名",
      sendInvitationEmail: "招待メールの送信",
      to: "宛先",
      title: "件名",
      content: "本文",
      cancel: "キャンセル",
      send: "送信",
      done: "決定",
      noUsers: "該当するユーザーが見つかりません",
      noGroups: "該当するグループが見つかりません。",
      searchUserName: "ユーザ名を検索する",
      noUserInAddressBook: "登録されているユーザがいません",
      sendInvitationByRole: "招待メールは役割ごとに送信してください",
      selectEmailAddress: "アドレス帳からユーザを選択してください",
      noAvailableGroup: "グループの登録がありません",
      selectRole: "招待メールを送信したい宛先の役割を選んでくだい。",
      addName: "名前を入力してください",
      addEmail: "メールアドレスを入力してください",
      selectRoleError: "役割を１つまたは複数選択してください",
      addEmailHint: "新規アドレスの個別登録ができます。",
      editGroupHint: "複数のアドレスをグループにまとめることができます。グループにまとめていると、グループ内のユーザに一括でメールを送信することができます。",
      importCSVHint: "複数のアドレスを一括で登録できます。",
      groupNamePlaceholder: "グループ名を入力",
      addGroupNameError: "グループ名を入力してください",
      csvUploadError: "CSVインポートに失敗しました。ファイルをご確認のうえ、再度お試しください。",
      confirmRole: "すでに選択されている役割と異なるものを選択される場合、宛先に追加された連絡先は全て削除されます。別の役割に変更してよろしいですか？",
      invitationHistory: "招待メール送信履歴",
      groupNameAlreadyUsed: "すでに同じグループ名が登録されています",
      noResultFound: "検索条件に一致する結果が見つかりません",
      csvDownload: "CSVファイル ダウンロード",
      exportCSVHint: "CSVインポート用のテンプレートファイルをダウンロードできます。",
      reselectRole: "役割再選択",
      searchAddressBook: "ユーザ名・アドレスを検索する",
      importAddressBookSuccess: "アドレスの一括登録が完了しました。",
      emailAdded: "アドレスの登録が完了しました。",
      likeToSendInvitation: "続けて招待メールを送信する場合は、送信したい宛先の役割を選択してください。",
      addressSaved: "アドレスの登録が完了しました。"
    }, invitations: {
      date: "送信日時",
      invitedUsers: "招待者",
      resend: "再送信",
      noInvitationFound: "送信履歴はありません",
      fetchingInvitations: "招待メールを取得しています"
    }, problemReport: {
      domainName: "ドメイン名/部屋名",
      date: "日時",
      problemType: "問題の種類",
      details: "詳細情報",
      description: "状況",
      downloadAttachment: "添付ファイルを表示",
      fetchingReport: "レポートを照合中",
      noReport: "レポートがありません"
    }
  }
}


// WEBPACK FOOTER //
// src/messages.js